<div class="guts-m-h-1-half guts-m-b-2 guts-p-t-2 m-guts-m-b-1 m-guts-m-h-1">
  <div
    class="l_flexbar l_flex-justify m-l_flexbar-col m-l_flexbar-block full-width"
  >
    <div class="guts-p-r-1 l_flex m-guts-p-r-0">
      <dgx-data-search
        [placeholder]="
          !isChannelContext && !isClientProvider
            ? ('OrgGroupsCtrl_SearchforGroup_With_Attribute' | translate)
            : ('OrgGroupsCtrl_SearchforGroup' | translate)
        "
        [searchTerm]="searchTerm"
        type="short"
        (doSearch)="updateQuery($event)"
      ></dgx-data-search>
      @if (filters?.length > 0 && !isChannelContext) {
        <dgx-data-filters
          [filters]="filters"
          class="guts-p-l-1"
          (filtersChange)="updateFilters($event)"
        ></dgx-data-filters>
      }
    </div>
    <div class="l_flexbar gap-full-half m-l_flexbar-col m-gap-full-1">
      @if (canCreateAnyGroup) {
        <button
          type="button"
          class="tw-btn-primary tw-btn-medium"
          (click)="addGroup($event)"
          data-dgat="orgGroups-938"
        >
          <da-icon
            icon="plus"
            type="solid-small"
            class="tw-reset tw-inline-block tw-align-middle"
          ></da-icon>
          {{ 'OrgGroupsCtrl_CreateAGroup' | translate }}
        </button>
      }
      @if (canUploadGroups) {
        <dgx-ftp-upload-link
          class="guts-m-l-0"
          buttonText="{{ 'OrgGroupsCtrl_UploadGroups' | translate }}"
          [fileUploadType]="fileType"
          icon="arrow-up-tray"
          [orgId]="orgId"
        ></dgx-ftp-upload-link>
      }
    </div>
  </div>
</div>
